module.exports = __webpack_public_path__ + "img/competitor.6bc2d90a.png";